import React from 'react';
import { motion } from 'framer-motion';

function Videos() {
  const videos = [
    { file: 'did1.mov', title: 'Stunning Portrait', description: 'Dandre showcasing his incredible facial features and natural charisma' },
    { file: 'did2.mov', title: 'Athletic Excellence', description: 'Watch Dandre demonstrate his athletic prowess and perfect form' },
    { file: 'did3.mov', title: 'Style Icon', description: 'Dandre effortlessly displaying his impeccable sense of style' },
    { file: 'did4.mov', title: 'Confident Presence', description: 'The camera loves Dandre as he radiates confidence and charm' },
    { file: 'did5.mov', title: 'Natural Model', description: 'Dandre proving he was born to be in front of the camera' },
    { file: 'did6.mov', title: 'Magnetic Personality', description: 'His infectious smile and magnetic personality shine through' },
    { file: 'did7.mov', title: 'Perfect Angles', description: 'Every angle is his best angle - absolutely photogenic perfection' },
    { file: 'did8.mov', title: 'Star Quality', description: 'Dandre displaying the star quality that makes him unforgettable' },
    { file: 'did9.mov', title: 'Flawless Finale', description: 'The perfect ending showcasing Dandre at his absolute best' }
  ];

  return (
    <motion.div 
      className="videos-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="videos-header">
        <motion.h1 
          className="videos-title"
          initial={{ y: -50 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          VIDEOS
        </motion.h1>
        <motion.p 
          className="videos-subtitle"
          initial={{ y: 50 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Watch Dandre in action - looking absolutely incredible in every frame
        </motion.p>
      </div>

      <div className="videos-grid">
        {videos.map((video, index) => (
          <motion.div 
            key={video.file}
            className="video-card"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ scale: 1.05 }}
          >
            <video 
              className="video-player"
              controls
              preload="metadata"
              muted
              playsInline
              webkit-playsinline
            >
              <source src={`/videos/${video.file}`} type="video/quicktime" />
              <source src={`/videos/${video.file}`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="video-overlay">
              <h3>{video.title}</h3>
              <p>{video.description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div 
        className="videos-description"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1 }}
      >
        <h2>The Star of Every Scene</h2>
        <p>
          These videos showcase Dandre's incredible presence and natural charisma. 
          From every angle and in every moment, he radiates confidence and style. 
          His photogenic nature and magnetic personality shine through in each frame, 
          making every video a masterpiece.
        </p>
        <p>
          Whether he's in motion or striking a pose, Dandre's exceptional looks and 
          undeniable charm make him the perfect subject for any camera. These videos 
          are a testament to his natural talent and stunning appearance.
        </p>
      </motion.div>
    </motion.div>
  );
}

export default Videos;